module.exports = __webpack_public_path__ + "img/karolina-libelt@1x.367793f9.jpg";